var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "brand-location-creator" },
    [
      _vm._l(_vm.internalLocations, function(location, index) {
        return _c("div", { key: index, staticClass: "card mb-3" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-5" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Şube Adı")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: location.name,
                        expression: "location.name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Örn: Kadıköy Şubesi" },
                    domProps: { value: location.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(location, "name", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-7" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Adres")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: location.address,
                        expression: "location.address"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Açık adres" },
                    domProps: { value: location.address },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(location, "address", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Telefon(lar)")]),
                    _vm._v(" "),
                    _vm._l(location.phones, function(phone, pIndex) {
                      return _c(
                        "div",
                        { key: pIndex, staticClass: "d-flex mb-2" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: location.phones[pIndex],
                                expression: "location.phones[pIndex]"
                              }
                            ],
                            staticClass: "form-control mr-2",
                            attrs: {
                              type: "text",
                              placeholder: "+90 5xx xxx xx xx"
                            },
                            domProps: { value: location.phones[pIndex] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  location.phones,
                                  pIndex,
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          location.phones.length > 1
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removePhone(index, pIndex)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                ×\n                            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.addPhone(index)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            + Telefon Ekle\n                        "
                        )
                      ]
                    )
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-3" }, [
                _c("label", [_vm._v("Enlem (latitude)")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: location.location.coordinates[1],
                      expression: "location.location.coordinates[1]"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", step: "any" },
                  domProps: { value: location.location.coordinates[1] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        location.location.coordinates,
                        1,
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3" }, [
                _c("label", [_vm._v("Boylam (longitude)")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: location.location.coordinates[0],
                      expression: "location.location.coordinates[0]"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", step: "any" },
                  domProps: { value: location.location.coordinates[0] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        location.location.coordinates,
                        0,
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-3 d-flex align-items-center" }, [
                _c("div", { staticClass: "togglebutton" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: location.isActive,
                          expression: "location.isActive"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(location.isActive)
                          ? _vm._i(location.isActive, null) > -1
                          : location.isActive
                      },
                      on: {
                        change: function($event) {
                          var $$a = location.isActive,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  location,
                                  "isActive",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  location,
                                  "isActive",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(location, "isActive", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "toggle" }),
                    _vm._v(
                      "\n                            Aktif\n                        "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-row",
                  staticStyle: { gap: "10px" }
                },
                [
                  location.id
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.updateLocation(index)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Güncelle\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.removeLocation(index)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        Şubeyi Sil\n                    "
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-outline-primary",
          attrs: { type: "button" },
          on: { click: _vm.addLocation }
        },
        [_vm._v("\n        + Yeni Şube Ekle\n    ")]
      ),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "locations" },
        domProps: { value: _vm.serializedLocations }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-099bdb0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-099bdb0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/vue/brand-location-creator.vue
// module id = 126
// module chunks = 0